import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { createStyles, makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Pagination from "@material-ui/lab/Pagination";
import Paper from "@material-ui/core/Paper";

import ListingsList from "./ListingsList";
import logo from "../../images/reportonce-logo.svg";
import OverlayError from "../Shared/OverlayError";
import OverlayLoading from "../Shared/OverlayLoading";

import * as actions from "../../redux/actions/index";
import CorporateListingsList from "./CorporateListingsList";
import FilterPanel from "./FilterPanel";

const useStyles = makeStyles((theme) =>
    createStyles({
        container: {
            paddingBottom: theme.spacing(3),
            paddingTop: theme.spacing(3),
        },
        pagination: {
            display: "flex",
            justifyContent: "center",
            paddingBottom: theme.spacing(2),
            paddingTop: theme.spacing(1),
        },
    })
);

export default function AllListings(props) {
    const listings = useSelector((state) => state.listings.listings);
    const error = useSelector((state) => state.listings.error);
    const errorMessage = useSelector((state) => state.listings.errorMessage);
    const errorCode = useSelector((state) => state.listings.errorCode);
    const loading = useSelector((state) => state.listings.loading);
    const pagesCount = useSelector((state) => state.listings.pages);
    const currentPage = useSelector((state) => state.listings.currentPage);
    const dispatch = useDispatch();
    const classes = useStyles();
    const isCorporate = useSelector((state) => state.user.userData.is_corporate)
    const groupID = useSelector((state) => state.user.userData.group)

    useEffect(() => {
        // code to run on component mount
        if (listings === null) {
            dispatch(actions.loadListings(1, isCorporate, {"group_id": groupID}));
        }
    }, [listings, dispatch]);

    const handlePaginationChange = (event, value) => {
        if (typeof listings[value] === "undefined") {
            dispatch(actions.loadListings(value, isCorporate, {"group_id": groupID}));
        } else {
            dispatch(actions.changeActivePage(value));
        }
    };

    return (
        <React.Fragment>
            <Container className={classes.container} maxWidth="md">
                <Paper style={{ position: "relative", marginBottom: '5px' }}>
                    <FilterPanel/>
                </Paper>
                <Paper style={{ position: "relative" }}>
                    {isCorporate ? <CorporateListingsList/> : <ListingsList/>}
                    <Pagination
                        className={classes.pagination}
                        hidePrevButton
                        hideNextButton
                        count={pagesCount}
                        page={currentPage}
                        onChange={handlePaginationChange}
                        disabled={loading}
                        color="primary"
                    />
                    <OverlayLoading loading={loading} />
                    <OverlayError
                        error={error}
                        errorMessage={errorMessage}
                        errorCode={errorCode}
                    />
                </Paper>
            </Container>
            <img
                src={logo}
                alt="ReportOnce Logo"
                width="200"
                height="42"
                style={{ margin: "0 auto 24px", display: "block" }}
            />
        </React.Fragment>
    );
}
